export const RegularKeyFramesEnum = {
    FadeAway: 'fadeAway',
    FadeIn: 'fadeIn',
    ResumeGlow: 'resumeGlow',
    ProjectGlow: 'projectGlow',
    ContactGlow: 'contactGlow'
}

export const SnowKeyFramesEnum = {
    DropRight: 'dropRight',
    DropLeft: 'dropLeft',
    DropTop: 'dropTop',
    DropTopLeft: 'dropTopLeft',
    DropTopRight: 'dropTopRight'
}

export const SnowTypesEnum = {
    Snow: 'snow',
    SmallSnow: 'smallSnow',
    BigSnow: 'bigSnow'
}

export const AnimationStylePresets = {
    NormalAnimation: 'animation',
    WebKitAnimation: 'WebkitAnimation',
    MozAnimation: 'MozAnimation',
    OAnimation: 'OAnimation',
    MsAnimation: 'MsAnimation'
}

export const UserMessages = {
    regularMessage: 'regularMessage'
}

export const MenuItems = {
    Resume: 'resume',
    Projects: 'projects',
    Contact: 'contact'
}

export const Socials = {
    LinkedIn: 'LinkedIn',
    LinkedInUri: 'https://linkedin.com/in/codebyluis',
    GitHub: 'GitHub',
    GitHubUri: 'https://github.com/LSanchez17'
}

export const FormIds = {
    Name: 'name',
    Email: 'email',
    Message: 'message',
    Text: 'text',
    Submit: 'submit',
}

export const ContactSection = {
    ContactSectionContainer: 'contactSectionContainer',
    ContactSection: 'contactSection',
}

export const ResumeContainer = {
    ResumeContainer: 'resumeContainer',
}

export const ProjectContainer = {
    ProjectContainer: 'projectContainer',
    Projects: 'projects',
}